import * as gradeActionTypes from '../actionTypes/index.js'
import * as commonActionTypes from '../../actions/actionTypes'

const initialState = {
  records: [],
  pagination: { total: 0, currentPage: 1, lastPage: 1, from: 0, to: 0, perPage: 10 },
  filters: null,
  selectedRecord: null,
  loadingStates: [],
  updateSuccess: false,
  deleteSuccess: false,

  companies: [],
  levelGroups: [],
  appraisalTypes: [],
  grades: []
}

const fetchGradesStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'records']
  }
}

const fetchGradesSuccess = (state, { records, pagination, filters }) => {
  return {
    ...state,
    records,
    pagination,
    filters,
    loadingStates: state.loadingStates.filter(item => item !== 'records')
  }
}

const fetchGradesFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'records')
  }
}

const fetchGradesByIdStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'recordById'] }
}

const fetchGradesByIdSuccess = (state, { recordData }) => {
  return {
    ...state,
    selectedRecord: recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'recordById')
  }
}

const fetchGradesByIdFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'recordById') }
}

const clearSelectedGradeRecord = state => {
  return {
    ...state,
    selectedRecord: null
  }
}

const createGradeStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'createRecord'], updateSuccess: false }
}

const createGradeSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'createRecord'),
    updateSuccess: true
  }
}

const createGradeFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'createRecord'),
    updateSuccess: false
  }
}

const updateGradeStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'updateRecord'], updateSuccess: false }
}

const updateGradeSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'updateRecord'),
    updateSuccess: true
  }
}

const updateGradeFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'updateRecord'),
    updateSuccess: false
  }
}

const deleteGradeStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'deleteRecord'], deleteSuccess: false }
}

const deleteGradeSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'deleteRecord'),
    deleteSuccess: true
  }
}

const deleteGradeFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'deleteRecord'),
    deleteSuccess: false
  }
}

const fetchCompanyOptionsStart = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id')
  }
}

const fetchCompanyOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    companies: data
  }
}

const fetchCompanyOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id')
  }
}

const fetchLevelGroupOptionsStart = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    levelGroups: []
  }
}

const fetchLevelGroupOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    levelGroups: data
  }
}

const fetchLevelGroupOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id')
  }
}

const fetchAppraisalTypeOptionsStart = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id')
  }
}

const fetchAppraisalTypeOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id'),
    appraisalTypes: data
  }
}

const fetchAppraisalTypeOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id')
  }
}

const fetchGradeOptionsStart = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'grade_id')
  }
}

const fetchGradeOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'grade_id'),
    grades: data
  }
}

const fetchGradeOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'grade_id')
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case gradeActionTypes.FETCH_GRADE_START:
      return fetchGradesStart(state)
    case gradeActionTypes.FETCH_GRADE_SUCCESS:
      return fetchGradesSuccess(state, action)
    case gradeActionTypes.FETCH_GRADE_FAILED:
      return fetchGradesFailed(state)

    case gradeActionTypes.FETCH_GRADE_BY_ID_START:
      return fetchGradesByIdStart(state)
    case gradeActionTypes.FETCH_GRADE_BY_ID_SUCCESS:
      return fetchGradesByIdSuccess(state, action)
    case gradeActionTypes.FETCH_GRADE_BY_ID_FAILED:
      return fetchGradesByIdFailed(state)

    case gradeActionTypes.CLEAR_SELECTED_GRADE_RECORD:
      return clearSelectedGradeRecord(state)

    case gradeActionTypes.CREATE_GRADE_START:
      return createGradeStart(state)
    case gradeActionTypes.CREATE_GRADE_SUCCESS:
      return createGradeSuccess(state)
    case gradeActionTypes.CREATE_GRADE_FAILED:
      return createGradeFailed(state)

    case gradeActionTypes.UPDATE_GRADE_START:
      return updateGradeStart(state)
    case gradeActionTypes.UPDATE_GRADE_SUCCESS:
      return updateGradeSuccess(state)
    case gradeActionTypes.UPDATE_GRADE_FAILED:
      return updateGradeFailed(state)

    case gradeActionTypes.DELETE_GRADE_START:
      return deleteGradeStart(state)
    case gradeActionTypes.DELETE_GRADE_SUCCESS:
      return deleteGradeSuccess(state)
    case gradeActionTypes.DELETE_GRADE_FAILED:
      return deleteGradeFailed(state)

    case commonActionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyOptionsStart(state)
    case commonActionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanyOptionsSuccess(state, action)
    case commonActionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyOptionsFailed(state)

    case commonActionTypes.FETCH_LEVEL_GROUP_OPTIONS_START:
      return fetchLevelGroupOptionsStart(state)
    case commonActionTypes.FETCH_LEVEL_GROUP_OPTIONS_SUCCESS:
      return fetchLevelGroupOptionsSuccess(state, action)
    case commonActionTypes.FETCH_LEVEL_GROUP_OPTIONS_FAILED:
      return fetchLevelGroupOptionsFailed(state)

    case commonActionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeOptionsStart(state)
    case commonActionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeOptionsSuccess(state, action)
    case commonActionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeOptionsFailed(state)

    case commonActionTypes.FETCH_GRADE_OPTIONS_START:
      return fetchGradeOptionsStart(state)
    case commonActionTypes.FETCH_GRADE_OPTIONS_SUCCESS:
      return fetchGradeOptionsSuccess(state, action)
    case commonActionTypes.FETCH_GRADE_OPTIONS_FAILED:
      return fetchGradeOptionsFailed(state)

    default:
      return state
  }
}

export default reducer
